<template>
    <div class="myskills" id="myskills">
        <div class="container">
            <div class="row">
                <div class="section-title">
                    <h2>My skills</h2>
                    <p>Here are a few technologies I’ve been working with :</p>
                </div>
                <div class="myskills__contents">
                    <div class="myskills__contents__dev wrapper ">
                        <input type="checkbox" id="folder" class="folders">
                        <label class="folder add_active" for="folder"><span class="folder-title">Apps</span></label>
                        <label class="fake-close-label" for="folder"></label>
                        <div class="folder-content">
                            <div class="app twitter">
                                <img src="../../assets/html.png" alt="">
                                <span>Html/Css</span>
                            </div>
                            <div class="app dribbble">
                                <img src="../../assets/wordpress.png" alt="">
                                <span>Wordpress</span>
                            </div>
                            <div class="app dropbox"><img src="../../assets/webpack.png" alt=""><span>Webpack</span></div>
                            <div class="app github"><img src="../../assets/javascript-48.png" alt=""><span>Javascript</span></div>
                            <div class="app codepen"><img src="../../assets/vue-js-48.png" alt=""><span>Vue js</span></div>
                            <div class="app codepen"><img src="../../assets/jquery.png" alt=""><span>jQuery</span></div>
                            <div class="app codepen"><img src="../../assets/php.png" alt=""><span>PHP</span></div>
                            <div class="app codepen"><img src="../../assets/prestashop.png" alt=""><span>Prestashop</span></div>
                            <div class="app codepen"><img src="../../assets/angular.png" alt=""><span>Angular</span></div>
                        </div>
                    </div>
                    <div class="myskills__contents__langue wrapper ">
                        <input type="checkbox" id="folder__langue" class="folders">
                        <label class="folder__langue add_active" for="folder__langue"><span class="folder-title__langue">Language</span></label>
                        <label class="fake-close-label__langue" for="folder__langue"></label>
                        <div class="folder-content__langue">
                            <div class="app twitter">
                                <img src="../../assets/english.png" alt="">
                                <span>English</span>
                            </div>
                            <div class="app twitter">
                                <img src="../../assets/france.png" alt="">
                                <span>Frensh</span>
                            </div>
                            <div class="app twitter">
                                <img src="../../assets/tunisia.png" alt="">
                                <span>Arabic</span>
                            </div>
                          
                        </div>
                    </div>
                    
                    <div class="myskills__contents__sofware wrapper ">
                        <input type="checkbox" id="folder__sofware" class="folders">
                        <label class="folder__sofware add_active" for="folder__sofware"><span class="folder-title__sofware">Software</span></label>
                        <label class="fake-close-label__sofware" for="folder__sofware"></label>
                        <div class="folder-content__sofware">
                            <div class="app figma">
                                <img src="../../assets/figma.png" alt="">
                                <span>Figma</span>
                            </div>
                            <div class="app photoshop">
                                <img src="../../assets/photoshop.png" alt="">
                                <span>Photoshop</span>
                            </div>
                            <div class="app illustrator">
                                <img src="../../assets/illustrator.png" alt="">
                                <span>Illustrator</span>
                            </div>
                            <div class="app ubuntu">
                                <img src="../../assets/ubuntu.png" alt="">
                                <span>Ubuntu</span>
                            </div>
                            <div class="app windows">
                                <img src="../../assets/windows.png" alt="">
                                <span>Windows</span>
                            </div>
                             <div class="app git">
                                <img src="../../assets/git.png" alt="">
                                <span>Git</span>
                            </div>
                            <div class="app vscode">
                                <img src="../../assets/vscode.png" alt="">
                                <span>Vscode</span>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <!--

                <div class="myskills__content">
                    

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            HTML/CSS
                        </div>
                        <div class="folder__description">
                            I USE THESE TECHNOLOGIES TO BRING MY DESIGN TO BROWSERS
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            JAVASCRIPT
                        </div>
                        <div class="folder__description">
                            WITH THIS TECHNOLOGY I CREATE VISUAL EFFECTS AND INTERACTION
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            VUE.JS
                        </div>
                        <div class="folder__description">
                           I USE IT TO CREATE APPLICATIONS THAT HAVE A LOT OF REACTIVITY
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            GULP
                        </div>
                        <div class="folder__description">
                           I USE IT FOR FLEXIBLE SETUP OF THE WORKING ENVIRONMENT
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            WEBPACK
                        </div>
                        <div class="folder__description">
                           I USE IT FOR THE SAME AS GULP :)
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            WORDPRESS
                        </div>
                        <div class="folder__description">
                           CONTENT MANAGEMENT SYSTEM. I USE IT TO MANAGE CONTENT
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            VUE.JS
                        </div>
                        <div class="folder__description">
                           I USE IT TO CREATE APPLICATIONS THAT HAVE A LOT OF REACTIVITY
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>

                    <div class="myskills__content__folder">
                        <div class="folder__title">
                            VUE.JS
                        </div>
                        <div class="folder__description">
                           I USE IT TO CREATE APPLICATIONS THAT HAVE A LOT OF REACTIVITY
                        </div>
                        <div class="folder__footer">
                            
                        </div>
                    </div>
                    
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/scss/skills.scss';
@import '@/scss/global.scss';
  
  
</style>

<script>
import $ from 'jquery'

export default {
  name: "my-skills",
  mounted(){
    $('input.folders').change(function(){
        if(this.checked){
            $('label.add_active').addClass('input_checked');
        }
        else {
         //do something else
         $('label.add_active').removeClass('input_checked');
    }
    })
    $('.myskills__contents__dev.wrapper input#folder').change(function(){
        if(this.checked){
            $('.folder-content__sofware').addClass('hide');
            $('.folder-content__langue').addClass('hide');
        }
        else {
            $('.folder-content__sofware').removeClass('hide');
            $('.folder-content__langue').removeClass('hide');
    }
    })

    $('.myskills__contents__langue.wrapper input#folder__langue').change(function(){
        if(this.checked){
            $('.folder-content__sofware').addClass('hide');
            $('.folder-content').addClass('hide');
        }
        else {
            $('.folder-content__sofware').removeClass('hide');
            $('.folder-content').removeClass('hide');
    }
    })

    $('.myskills__contents__sofware.wrapper input#folder__sofware').change(function(){
        if(this.checked){
            $('.folder-content__langue').addClass('hide');
            $('.folder-content').addClass('hide');
        }
        else {
            $('.folder-content__langue').removeClass('hide');
            $('.folder-content').removeClass('hide');
    }
    })
  }
};
</script>
